module.exports = __webpack_public_path__ + "static/media/capa.ecadb0a2.svg";